module.exports = __webpack_public_path__ + "img/Location_Image.324742ce.jpg";